import { Outlet, useLocation, useNavigate } from "react-router-dom";
import SessionTimeoutModal from "../../SessionTimeoutModal";
import Header from "../panels/Header";
import SideBar from "../panels/SideBar";
import { useEffect } from "react";
import { localStorageUtils } from "../../../utils/LocalStorageUtil";
import { routePublic } from "../../../routes/PublicRoutePath";

const AdminLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const storedAccessToken = localStorageUtils.getAccessToken();
    if (location.pathname !== "/" + routePublic.unauthorizedAccess) {
      if (storedAccessToken) {
        navigate(location);
      } else {
        localStorage.clear();
        navigate("/" + routePublic.login);
      }
    }
  }, []);

  return (
    <div className="flex h-svh overflow-hidden bg-base">
      <SideBar />
      <div className="flex flex-col flex-1 overflow-hidden">
        <Header />
        <div className="flex-1 overflow-y-scroll flex flex-col ">
          <Outlet />
        </div>
        <SessionTimeoutModal />
      </div>
    </div>
  );
};

export default AdminLayout;
